module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In loving memory of my late wife and soulmate")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Evelyn Jean Tremain")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(1952–2022)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf8bfea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Memory.vue
// module id = 60
// module chunks = 0